<script setup>
import { computed, defineEmits, defineProps, nextTick, ref } from 'vue';

const props = defineProps({ value: String, countryCodeList: Array });
const emit = defineEmits(['input']);
const countryCode = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit('input', val);
  },
});

// 修复 IOS 无法唤起软键盘的兼容性问题
const selectRef = ref();

const clear = async => {
  nextTick(() => {
    if (async) {
      return;
    }
    setTimeout(() => {
      const input = selectRef.value.$el.querySelector('.el-input__inner');
      input.removeAttribute('readonly');
    }, 200);
  });
};
</script>

<template>
  <el-select
    v-model="countryCode"
    ref="selectRef"
    @focus="clear"
    @hook:mounted="clear"
    @visible-change="clear"
    filterable
    class="country-code"
    popper-class="country-code-popper"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in props.countryCodeList"
      :key="item.key"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<style scoped lang="less">
.country-code {
  :deep(.el-input__inner) {
    padding-left: 8px;
    padding-right: 25px;
  }

  :deep(.el-input__suffix) {
    right: 0;
  }
}

:deep(.country-code-popper) {
  left: 0 !important;
}

:deep(.el-icon-arrow-up)::before {
  color: #191919;
}
</style>
